import _taggedTemplateLiteral from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';
import { Link, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles(function (_ref) {
  var palette = _ref.palette;
  return {
    title: {
      lineHeight: 'normal',
      color: palette.primary.contrastText
    }
  };
});
var IconContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n  margin-right: 8px;\n  vertical-align: middle;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  & > * {\n    width: 24px;\n    height: 24px;\n  }\n  ", "\n"])), function (_ref2) {
  var palette = _ref2.theme.palette;
  return "\n    fill: ".concat(palette.primary.contrastText, ";\n    color: ").concat(palette.primary.contrastText, ";\n  ");
});
var BrandLink = styled(Link).attrs(function () {
  return {
    underline: 'none'
  };
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
var BrandContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-grow: 1;\n"])));

var Brand = function Brand(_a) {
  var children = _a.children,
      _a$href = _a.href,
      href = _a$href === void 0 ? '/' : _a$href,
      title = _a.title,
      rest = __rest(_a, ["children", "href", "title"]);

  var classes = useStyles();
  return React.createElement(BrandContainer, Object.assign({}, rest), React.createElement(BrandLink, {
    href: href
  }, children && React.createElement(IconContainer, null, children), title && React.createElement(Typography, {
    className: classes.title,
    variant: "h6"
  }, title)));
};

Brand.displayName = 'Navbar.Brand';
var BrandExtra = styled(Brand)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([""])));
export default BrandExtra;